import { useAdminSchools, useAdminProfiles } from '@/hooks/useAdminDirectory'
import { AdminProfileList } from './AdminProfileList'
import { sectionStyle, sectionTitleStyle, rowStyle, pageTitleStyle, pageSubtitleStyle, statusPillStyle } from './adminListStyles'

export default function AdminSchools() {
  const { schools, loading: schoolsLoading } = useAdminSchools()
  const { profiles, loading: profilesLoading, updating, setAccountStatus } = useAdminProfiles()

  const schoolAdmins = profiles.filter(p => p.primaryRole === 'school_admin')

  return (
    <div style={{ maxWidth: 900 }}>
      <div style={pageTitleStyle}>Schools</div>
      <div style={pageSubtitleStyle}>
        Platform-wide view of every registered school and its admin account. No payment processing is wired up
        here — seat usage is shown for visibility, not billing.
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Driving schools ({schools.length})</div>
        {schoolsLoading ? <div style={{ color: 'rgba(27,42,74,0.4)' }}>Loading…</div> : schools.length === 0 ? (
          <div style={{ color: 'rgba(27,42,74,0.4)' }}>No schools registered yet.</div>
        ) : schools.map(s => (
          <div key={s.id} style={rowStyle}>
            <div style={{ flex: '1 1 220px', font: '600 13.5px Inter, sans-serif', color: '#1B2A4A' }}>{s.name}</div>
            <div style={{ flex: '1 1 150px', font: '400 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.55)' }}>
              {s.city ?? '—'} · {s.mtoLicenceNumber ?? 'no MTO #'}
            </div>
            <div style={{ font: '400 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.55)' }}>
              {s.activeInstructorCount}{s.maxInstructorSeats != null ? ` / ${s.maxInstructorSeats}` : ''} seats
            </div>
            <div style={statusPillStyle(s.accountStatus)}>{s.accountStatus}</div>
          </div>
        ))}
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>School admins ({schoolAdmins.length})</div>
        <AdminProfileList profiles={schoolAdmins} loading={profilesLoading} updating={updating} onSetStatus={setAccountStatus} />
      </div>
    </div>
  )
}
